import React from 'react';
import { ICalendarDate } from '../../Calendar';
import { IDateFormat, transformSingleDateToInputString } from '../../helpers/validators';
import { ICalendarPosition } from '../CalendarView';
require("./CalendarViewResultPreview.css");
var styles = {
  "Root": "CalendarViewResultPreview-module-Root_38T"
};
export const CalendarViewResultPreview = ({
  dateFormat,
  calendarPosition,
  selectedDateOne,
  selectedDateTwo,
  separator
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.Root
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.ResultPreview
  }, calendarPosition === 'primary' && (selectedDateOne ? transformSingleDateToInputString({
    date: selectedDateOne,
    dateFormat,
    separator
  }) : 'Выберите дату...'), calendarPosition === 'secondary' && (selectedDateTwo ? transformSingleDateToInputString({
    date: selectedDateTwo,
    dateFormat,
    separator
  }) : 'Выберите дату...')));
};